import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab, faFacebook } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  fas,
  faCoffee,
  faCog,
  faSpinner,
  faQuoteLeft,
  faSquare,
  faCheckSquare,
  faHome,
  faEnvelope,
  faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import Password from "../Login/Password";
import axios from "axios";

library.add(
  fab,
  faCoffee,
  faCog,
  faSpinner,
  faQuoteLeft,
  faSquare,
  faCheckSquare,
  faFacebook,
  faHome,
  faEnvelope,
  faPhoneAlt
);

const Header = (props) => {
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleLogout = () => setDropdownOpen((prevState) => !prevState);

  const [dropdownOpenModelos, setDropdownOpenModelos] = useState(false);
  const toggleModelos = () => setDropdownOpenModelos((prevState) => !prevState);

  const [dropdownOpenCompras, setDropdownOpenCompras] = useState(false);
  const toggleCompras = () => setDropdownOpenCompras((prevState) => !prevState);

  const [dropdownOpenVentas, setDropdownOpenVentas] = useState(false);
  const toggleVentas = () => setDropdownOpenVentas((prevState) => !prevState);

  const [dropdownOpenVentasWhatsapp, setDropdownOpenVentasWhatsapp] = useState(false);
  const toggleVentasWhatsapp = () => setDropdownOpenVentasWhatsapp((prevState) => !prevState);

  const [dropdownOpenFinanzas, setDropdownOpenFinanzas] = useState(false);
  const toggleFinanzas = () =>
    setDropdownOpenFinanzas((prevState) => !prevState);

  const [dropdownOpenTiendas, setDropdownOpenTiendas] = useState(false);
  const toggleTiendas = () => setDropdownOpenTiendas((prevState) => !prevState);

  const [dropdownOpenInventarios, setDropdownOpenInventarios] = useState(false);
  const toggleInventarios = () =>
    setDropdownOpenInventarios((prevState) => !prevState);

  const [dropdownOpenGastos, setDropdownOpenGastos] = useState(false);
  const toggleGastos = () => setDropdownOpenGastos((prevState) => !prevState);

  const [dropdownOpenFiscal, setDropdownOpenFiscal] = useState(false);
  const toggleFiscal = () => setDropdownOpenFiscal((prevState) => !prevState);

  const [dropdownOpenEmpleados, setDropdownOpenEmpleados] = useState(false);
  const toggleEmpleados = () =>
    setDropdownOpenEmpleados((prevState) => !prevState);

  const [dropdownOpenAdmin, setDropdownOpenAdmin] = useState(false);
  const toggleAdmin = () => setDropdownOpenAdmin((prevState) => !prevState);

  const [dropdownOpenCXP, setDropdownOpenCXP] = useState(false);
  const toggleCXP = () => setDropdownOpenCXP((prevState) => !prevState);

  const [dropdownOpenReportes, setDropdownOpenReportes] = useState(false);
  const toggleReportes = () =>
    setDropdownOpenReportes((prevState) => !prevState);

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { isAuth, user, shouldShowPaymentWarning } = useContext(AuthContext);
  const [modalPassword, setModalPassword] = useState(false);
  const togglePassword = () => setModalPassword(!modalPassword);

  const [status, setStatus] = useState("Esperando Estado...");

  useEffect(() => {
    axios
    .get(`${URL_WHATSAPP}Status`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allStatus = response.data.state;
      setStatus(allStatus);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);

  return (
    <>
      {isAuth ? (
        <header className="sticky-top">
          {!user.menu_edoCta_Cliente && !user.menu_cobradores ? (
            <Navbar color="dark" dark expand="lg">
              {/* <a href="https://gloss.sistemify.com/"> */}
              <a href="/Inicio">
                <img
                  src={"/LogoSistemify2RS.png"}
                  height="50 px"
                  alt="logo"
                />
              </a>
              <NavbarToggler onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                <Nav className="mr-auto" navbar>
                  {
                    user.areaEsTienda == "No"? (
                      <>
                        {user.menu_catalogos ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenModelos}
                                toggle={toggleModelos}
                              >
                                <DropdownToggle color="link">
                                  CATALOGOS
                                </DropdownToggle>
                                <DropdownMenu style={{ minWidth: '500px', padding: '10px' }}>
                                  <div style={{ display: 'flex', gap: '20px' }}>
                                    {/* Primera columna */}
                                    <div style={{ flex: 1, paddingRight: '10px', borderRight: '1px solid #dee2e6' }}>
                                      <DropdownItem href="/ListadoArticulos">
                                        Modelos
                                      </DropdownItem>
                                      <DropdownItem href="/GeneradorEtiquetas">
                                        Generador Etiquetas
                                      </DropdownItem>
                                      <DropdownItem href="/Colores">
                                        Colores
                                      </DropdownItem>
                                      <DropdownItem href="/Tallas">
                                        Tallas
                                      </DropdownItem>
                                      <DropdownItem href="/ListadoArticulosFoto">
                                        Fotos Modelos
                                      </DropdownItem>
                                      <DropdownItem href="/Lineas">
                                        Lineas
                                      </DropdownItem>
                                      <DropdownItem href="/Marcas">
                                        Marcas
                                      </DropdownItem>
                                      <DropdownItem href="/Familias">
                                        Familias
                                      </DropdownItem>
                                      <DropdownItem href="/Colecciones">
                                        Colecciones
                                      </DropdownItem>
                                      <DropdownItem href="/Proveedores">
                                        Proveedores
                                      </DropdownItem>
                                    </div>
                                    
                                    {/* Segunda columna */}
                                    <div style={{ flex: 1, paddingLeft: '10px' }}>
                                      <DropdownItem href="/Clientes">
                                        Clientes
                                      </DropdownItem>
                                      {/* <DropdownItem href="/DepartamentosClientes">
                                        Departamentos Clientes
                                      </DropdownItem> */}
                                      <DropdownItem href="/Paqueterias">
                                        Paqueterias
                                      </DropdownItem>
                                      <DropdownItem href="/Grupos">
                                        Grupos Clientes
                                      </DropdownItem>
                                      <DropdownItem href="/ConceptosGastos">
                                        Conceptos Gastos
                                      </DropdownItem>
                                      <DropdownItem href="/Bancos">
                                        Bancos
                                      </DropdownItem>
                                      {/* <DropdownItem href="/MenuConfiguraciones">
                                        Configuracion
                                      </DropdownItem> */}
                                      <DropdownItem href="/Areas">
                                        Areas
                                      </DropdownItem>
                                    </div>
                                  </div>
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menu_compras ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenCompras}
                                toggle={toggleCompras}
                              >
                                <DropdownToggle color="link">
                                  COMPRAS
                                </DropdownToggle>
                                <DropdownMenu>
                                  {/* <DropdownItem href="/ListadoOrdenesCompra">
                                    Ordenes de Produccion
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoEmbarques">
                                    Embarques
                                  </DropdownItem> */}
                                  <DropdownItem href="/ListadoCompras">
                                    Entradas
                                  </DropdownItem>
                                  {/* <DropdownItem href="/ListadoComprasCXP">
                                    Notas CxP
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoPendRecibir">
                                    Pendiente Recibir
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoPendEmbarcar">
                                    Pendiente Embarcar
                                  </DropdownItem> */}
                                  {/* <DropdownItem href="/ListadoControlCalidad">Control Calidad</DropdownItem> */}
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menu_ventas ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenVentas}
                                toggle={toggleVentas}
                              >
                                <DropdownToggle color="link">
                                  VENTAS
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem href="/ListadoPedidos">
                                    Pedidos
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoPendienteSurtir">
                                    Surtir
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoDevoluciones">
                                    Devoluciones
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoVentas">
                                    Ventas
                                  </DropdownItem>
                                  <DropdownItem href="/AnalisisArticulosPedidos">
                                    Analisis Pedidos
                                  </DropdownItem>
                                  <DropdownItem href="/ListoSurtir">
                                    Listo Surtir
                                  </DropdownItem>
                                  <DropdownItem href="/ListoSurtirCliente">
                                    Listo Surtir Cliente
                                  </DropdownItem>
                                  <div className="dropdown-divider"></div>
                                  <DropdownItem href="/ReporteUltimoPrecio">
                                    Ultimo Precio Cliente
                                  </DropdownItem>
                                  <DropdownItem href="/ReporteUltimoPrecioArticulo">
                                    Ultimo Precio Articulo
                                  </DropdownItem>
                                  {/* <div className="dropdown-divider"></div>
                                  <DropdownItem href="/ReporteVentasPorVendedor">
                                    Reporte Vendedores
                                  </DropdownItem> */}
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}



                        {user.menu_admin ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenFinanzas}
                                toggle={toggleFinanzas}
                              >
                                <DropdownToggle color="link">
                                  FINANZAS
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem href="/EstadoCuenta">
                                    Estados de Cuenta Clientes
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoAnticipos">
                                    Anticipos
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoAbonos">
                                    Abonos
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoNotasCargo">
                                    Notas de Cargo
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoDevolucionesAdmin">
                                    Aplicar Devoluciones
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoAbonosProveedores">
                                    Pagos Proveedores
                                  </DropdownItem>
                                  <DropdownItem href="/EstadoCuentaCXP">
                                    Estados de Cuenta Proveedores
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoComisiones">
                                    Comisiones
                                  </DropdownItem>
                                  {/* <DropdownItem href="/ListadoComisiones">Comisiones</DropdownItem>
                            <DropdownItem href="/ListadoTraspasosDinero">Traspasos Dinero</DropdownItem> */}
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menu_inventarios ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenInventarios}
                                toggle={toggleInventarios}
                              >
                                <DropdownToggle color="link">
                                  INVENTARIOS
                                </DropdownToggle>
                                <DropdownMenu>
                                  {/* <div className="dropdown-divider"></div> */}
                                  <DropdownItem href="/ListadoInventarios">
                                    Inventarios
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoDisponible">
                                    Disponible 
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoTracking">
                                    Tracking
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoKardex">
                                    Kardex
                                  </DropdownItem>
                                  <div className="dropdown-divider"></div>
                                  <DropdownItem href="/MenuTraspasos">
                                    Traspasos
                                  </DropdownItem>
                                  <div className="dropdown-divider"></div>
                                  <DropdownItem href="/ListadoAjustesInventario">
                                    Ajuste Inventario
                                  </DropdownItem>
                                  {/* <div className="dropdown-divider"></div> */}
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menu_admin ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenGastos}
                                toggle={toggleGastos}
                              >
                                <DropdownToggle color="link">
                                  GASTOS
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem href="/ConceptosGastos">
                                   Conceptos Gastos
                                  </DropdownItem>
                                  <DropdownItem href="/Gastos">
                                    Gastos
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                {user.menu_fiscal ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenFiscal}
                                toggle={toggleFiscal}
                              >
                                <DropdownToggle color="link">
                                  FISCAL
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem href="/ListadoEmpresas">
                                    Empresas
                                  </DropdownItem>
                                  <DropdownItem href="/RegistrarEmpresas">
                                    Registrar FIEL
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoFacturas">
                                    Facturacion
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoComplementosPago">
                                    Complementos de Pago
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoNotasCredito">
                                    Notas de Credito
                                  </DropdownItem>
                                  <DropdownItem href="/ListadoDevolucionesFiscal">
                                    Devoluciones
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menu_empleados ? (
                          <NavItem>
                            <NavLink className="titulosNav">
                              <Dropdown
                                isOpen={dropdownOpenEmpleados}
                                toggle={toggleEmpleados}
                              >
                                <DropdownToggle color="link">
                                  USUARIOS
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem href="/Empleados">
                                    Usuarios
                                  </DropdownItem>
                                  <DropdownItem href="/Puestos">
                                    Puestos
                                  </DropdownItem>
                                  <DropdownItem href="/MenuUsuarios">
                                    Permisos
                                  </DropdownItem>
                                  {/* <DropdownItem href="/Nominas">Nominas</DropdownItem>
                      <DropdownItem href="/FaltasColaboradores">Faltas Empleados</DropdownItem> */}
                                </DropdownMenu>
                              </Dropdown>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                  {user.menu_admin ? (
                          <NavItem>
                            <NavLink href="/WhatsApp">
                              <DropdownToggle color="link" style={{ color: status === 2 ? 'green' : 'red' }} >
                                WHATSAPP
                              </DropdownToggle>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menu_reportes ? (
                          <NavItem>
                            <NavLink
                              className="titulosNav"
                              href="/MenuReportes"
                            >
                              <DropdownToggle color="link">
                                REPORTES
                              </DropdownToggle>
                            </NavLink>
                          </NavItem>
                        ) : undefined}


                        {user.menu_logs ? (
                          <NavItem>
                            <NavLink className="titulosNav" href="/MenuLogs">
                              <DropdownToggle color="link">LOGS</DropdownToggle>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menu_ia ? (
                          <NavItem>
                            <NavLink className="titulosNav" href="/AsistenteIA">
                              <DropdownToggle color="link">ASISTENTE IA</DropdownToggle>
                            </NavLink>
                          </NavItem>
                        ) : undefined}

                        {user.menuTiendas ? (
                          <NavItem>
                            <NavLink className="titulosNav" href="/MenuTiendas">
                              <DropdownToggle color="link">
                                TIENDAS
                              </DropdownToggle>
                            </NavLink>
                          </NavItem>
                        ) : undefined}
                      </>
                    ) : (
                      <>
                        {user.menuTiendas ? (
                          <NavItem>
                            <NavLink className="titulosNav" href="/MenuTiendas">
                              <DropdownToggle color="link">
                                TIENDAS
                              </DropdownToggle>
                            </NavLink>
                          </NavItem>
                        ) : undefined}
                      </>
                    )
                  }
                </Nav>
                <NavbarText>
                  <NavLink className="titulosNav">
                    <Dropdown
                      direction="left"
                      isOpen={dropdownOpen}
                      toggle={toggleLogout}
                    >
                      <DropdownToggle color="link">
                        <i className="fas fa-user-cog fa-2x"></i>
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem href="/logout">Logout</DropdownItem>
                        <DropdownItem onClick={togglePassword}>
                          Password
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </NavLink>
                </NavbarText>
                <Modal size="sm" isOpen={modalPassword} toggle={togglePassword}>
                  <ModalHeader toggle={togglePassword}>
                    <h4>Cambio de contraseña</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Password />
                  </ModalBody>
                </Modal>
              </Collapse>
            </Navbar>
          ) : (
            <Navbar color="dark" dark expand="md">
              <a href="/Inicio">
                <img
                  src={"/LogoSistemify2RS.png"}
                  height="50 px"
                  alt="logo"
                />
              </a>
              <NavbarToggler onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                <NavbarText>
                  <NavLink className="titulosNav" href="/logout"></NavLink>
                </NavbarText>
              </Collapse>
            </Navbar>
          )}

          
                {shouldShowPaymentWarning && (
                  <h4 align="center">SU CUENTA PRESENTA UN ADEUDO LE SOLICITAMOS RELIZAR EL PAGO A LA BREVEDAD</h4>
                )}
                
        </header>
      ) : undefined}
    </>
  );
};

export default Header;
